import { render } from "./CpAbstractsOverviewItem.vue?vue&type=template&id=7810466e&scoped=true&ts=true"
import script from "./CpAbstractsOverviewItem.vue?vue&type=script&lang=ts"
export * from "./CpAbstractsOverviewItem.vue?vue&type=script&lang=ts"

import "./CpAbstractsOverviewItem.vue?vue&type=style&index=0&id=7810466e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7810466e"]])

export default __exports__